export default __webpack_public_path__ + "static/media/icon-12.cf93d39f.svg";